(() => {
  if (window.dksMobileNavigation) {
    window.dksMobileNavigation.init(document);
    return;
  }

  const menus = new WeakMap();

  function mount(header) {
    if (menus.has(header)) return;
    const trigger = header.querySelector('[data-menu-open]');
    const dialog = header.querySelector('[data-mobile-menu]');
    const closeButton = header.querySelector('[data-menu-close]');
    if (!trigger || !dialog || !closeButton) return;

    const controller = new AbortController();
    const options = { signal: controller.signal };
    const mobile = window.matchMedia('(max-width: 767px)');
    let scrollState = null;
    let returnFocus = true;
    let startedOutside = false;

    function unlockScroll() {
      if (!scrollState) return;
      const { x, y, body, rootOverflow, rootScrollBehavior } = scrollState;
      Object.assign(document.body.style, body);
      document.documentElement.style.overflow = rootOverflow;
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo(x, y);
      document.documentElement.style.scrollBehavior = rootScrollBehavior;
      scrollState = null;
    }

    function close(restoreFocus = true) {
      returnFocus = restoreFocus;
      if (dialog.open) dialog.close();
    }

    trigger.addEventListener('click', () => {
      if (!mobile.matches || dialog.open) return;
      const body = document.body.style;
      scrollState = {
        x: window.scrollX,
        y: window.scrollY,
        body: { position: body.position, top: body.top, left: body.left, width: body.width, overflow: body.overflow },
        rootOverflow: document.documentElement.style.overflow,
        rootScrollBehavior: document.documentElement.style.scrollBehavior
      };
      Object.assign(body, { position: 'fixed', top: `-${scrollState.y}px`, left: '0', width: '100%', overflow: 'hidden' });
      document.documentElement.style.overflow = 'hidden';
      returnFocus = true;
      dialog.showModal();
      trigger.setAttribute('aria-expanded', 'true');
    }, options);

    closeButton.addEventListener('click', () => close(), options);
    dialog.addEventListener('cancel', event => {
      event.preventDefault();
      close();
    }, options);
    dialog.addEventListener('close', () => {
      trigger.setAttribute('aria-expanded', 'false');
      unlockScroll();
      if (returnFocus && mobile.matches && trigger.isConnected) trigger.focus({ preventScroll: true });
    }, options);

    function isOutside(event) {
      const rect = dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    }

    dialog.addEventListener('pointerdown', event => {
      startedOutside = event.target === dialog && isOutside(event);
    }, options);
    dialog.addEventListener('click', event => {
      if (startedOutside && event.target === dialog && isOutside(event)) close();
      else if (event.target.closest('a[href]')) close(false);
      startedOutside = false;
    }, options);

    const groups = [...dialog.querySelectorAll('.dks-menu-group')];
    groups.forEach(group => group.addEventListener('toggle', () => {
      if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
    }, options));

    mobile.addEventListener('change', () => {
      if (!mobile.matches) close(false);
    }, options);

    menus.set(header, () => {
      close(false);
      unlockScroll();
      controller.abort();
      menus.delete(header);
    });
  }

  function init(root) {
    root.querySelectorAll('[data-dks-mobile-navigation]').forEach(mount);
  }

  window.dksMobileNavigation = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-dks-mobile-navigation]').forEach(header => menus.get(header)?.());
  });
})();
